import { useState, useCallback, useRef, useEffect } from "react";
import { FieldsLayout } from "./layout";
import ChoiceMappingsContent from "../choice-mappings";

const ChoiceMappingsPage = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const refreshFnRef = useRef<(() => void) | undefined>();

  // DEBUG: Render counter
  const renderCount = useRef(0);
  renderCount.current++;
  console.log(`[ChoiceMappingsPage (fields)] Render #${renderCount.current}, isRefreshing=${isRefreshing}`);

  const handleRefreshReady = useCallback((fn: () => void, refreshing: boolean) => {
    console.log(`[ChoiceMappingsPage (fields)] handleRefreshReady called, refreshing=${refreshing}`);
    refreshFnRef.current = fn;
    // Only update state if it actually changed to prevent re-renders
    setIsRefreshing(prev => {
      if (prev !== refreshing) {
        console.log(`[ChoiceMappingsPage (fields)] isRefreshing changing: ${prev} -> ${refreshing}`);
        return refreshing;
      }
      return prev;
    });
  }, []);

  const handleRefresh = useCallback(() => {
    refreshFnRef.current?.();
  }, []);

  return (
    <FieldsLayout onRefresh={handleRefresh} isRefreshing={isRefreshing}>
      <ChoiceMappingsContent onRefreshReady={handleRefreshReady} />
    </FieldsLayout>
  );
};

export default ChoiceMappingsPage;
